module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "crudApi": _vm.crudApi,
      "tableData": _vm.messagesData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleHospitalLevelChange,
      "afterDelete": _vm.handleHospitalLevelChange,
      "selectedDataArray": _vm.selectedData,
      "customListResult": true
    },
    on: {
      "update:tableData": function($event) {
        _vm.messagesData = $event
      },
      "update:table-data": function($event) {
        _vm.messagesData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "customResult"
  }, _vm._l((_vm.messagesData), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "message-box"
    }, [_c('div', {
      staticClass: "message-box-title"
    }, [_vm._v("\n                【" + _vm._s(data.titile) + "】 " + _vm._s(data.sendTime) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "message-box-content"
    }, [_c('div', {
      staticClass: "message-box-content-info"
    }, [_vm._v(_vm._s(_vm._f("removeHtmlTag")((data.msgContent ? data.msgContent : ' '))))]), _vm._v(" "), _c('div', {
      staticClass: "message-box-content-operator"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.meetingId),
        expression: "data.meetingId"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleViewClick(data)
        }
      }
    }, [_vm._v("\n                      查看\n                  ")])], 1)])])
  }), 0), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("医院层级")])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60b986d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b986d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/messages/list/index.vue
// module id = 1581
// module chunks = 7